import { Component, OnInit, ChangeDetectorRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { AppService } from 'src/app/services/app.service';
import { CustomerService } from 'src/app/services/customer.service';
import { MatDialog, MatStepper, throwMatDialogContentAlreadyAttachedError } from '@angular/material';
import { LoginComponent } from 'src/app/partials/login/login.component';
import { DomSanitizer } from '@angular/platform-browser';
import { StateService } from 'src/app/services/states.service';
import { FormGroup, FormBuilder, FormControl, FormControlName, Validators } from '@angular/forms';
import { trigger } from '@angular/animations';
import {  ActivatedRoute, Router, RoutesRecognized } from '@angular/router';
import { filter, pairwise } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { isString } from 'util';
import { RouteEvents } from 'src/app/guard/router-events';
@Component({
  selector: 'app-tarifs',
  templateUrl: './tarifs.component.html',
  styleUrls: ['./tarifs.component.scss']
})
export class TarifsComponent implements OnInit {
  store:any;
  cart:any;
  refCart:any = "";
  user: any;
  facture: any;
  url_confirmation: any;
  adresseForm: FormGroup = new FormGroup({});
  previousurl: any = "";
  optionsVille:any = false;
  ODOO_URL: string = environment.ODOO_URL;
  messageError:string = "";
  isBuying = false;
  directDevis: any;
  refDossier: string = null;
  waitingDossierCreation: boolean = false;
  @ViewChild('stepper', {static : false}) private myStepper: MatStepper;
  

  constructor(
    private customerService: CustomerService,
    private route: ActivatedRoute,
    private appService: AppService,
    public dialog: MatDialog,
    private formBuilder: FormBuilder,
    public _sanitizer: DomSanitizer,
    public stateService: StateService,
    private cdf: ChangeDetectorRef,
    private router: Router,
    private routeEvents: RouteEvents
  ) {
    this.listenerIframe = this.listenerIframe.bind(this);
    let extras = this.router.getCurrentNavigation().extras;
    this.directDevis = extras.hasOwnProperty('state') && extras.state && extras.state.hasOwnProperty('directDevis') ? extras.state.directDevis : false;
  }

  ngOnInit() {
	window['tryga']('send', 'event', 'connexion', 'tarif', '', '');
    this.stateService.user.subscribe((user) => {
      this.ODOO_URL = environment.ODOO_URL;// si la première page de navigation est tarif, alors le component Tarif est construct avant le retour de getEnv de app.component et donc ODOO_URL n'a pas la bonne valeur => donc réaffectation ici pour etre sur d'avoir la bonne valeur
      this.user = user;
      this.cart = [];

      
      if(this.user && !this.directDevis){
        this.adresseForm = this.formBuilder.group({
          nomadresse: new FormControl(this.user.adresse.nomadresse ? this.user.adresse.nomadresse : user.name, [Validators.required]),
          emailadresse: new FormControl(this.user.adresse.emailadresse ? this.user.adresse.emailadresse : this.user.email, [
            Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"),
            Validators.required
          ]),
          telephone: new FormControl(this.user.adresse.telephone, [Validators.required]),
          entreprise: new FormControl(this.user.firm),
          rue: new FormControl(this.user.adresse.rue, [Validators.required]),
          ruecomp: new FormControl(this.user.adresse.ruecomp),
          ville: new FormControl(this.user.adresse.ville, [Validators.required]),
          codepost: new FormControl(this.user.adresse.codepost, [Validators.required]),
          pays: new FormControl(this.user.adresse.pays ?this.user.adresse.pays : "France", [Validators.required])
        });
      } else {
        this.adresseForm = this.formBuilder.group({
          nomadresse: new FormControl("", [Validators.required]),
          emailadresse: new FormControl("", [
            Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"),
            Validators.required
          ]),
          telephone: new FormControl("", [Validators.required]),
          entreprise: new FormControl(""),
          rue: new FormControl("", [Validators.required]),
          ruecomp: new FormControl(""),
          ville: new FormControl("", [Validators.required]),
          codepost: new FormControl("", [Validators.required]),
          pays: new FormControl("France", [Validators.required])
        });
      }
      if(this.user){
        this.customerService.GetStore().subscribe((res) => {
          this.afterGetStore(res.result);
        });
      } else {
        this.customerService.getPublicStore().subscribe((res) => {
          this.afterGetStore(res.result);
        });
      }
    });

    window.addEventListener('message',this.listenerIframe,false);
  }
  ngAfterViewInit() {
    if (this.directDevis) {
      this.customerService.buyPredefinedItem().subscribe((res) => {
        if(res.result.error){
          this.messageError = res.result.error
        }else{
          this.myStepper.selectedIndex = 2;
          this.messageError = ""
          if(res && res.result && res.result.result) {
              this.refCart = res.result.result.order_id

              let url = res.result.result.url_confirmation.replace('http:', 'https:')
              this.url_confirmation = this._sanitizer.bypassSecurityTrustResourceUrl(url);
              
              let urlids = res.result.result.urlcustomer.replace('http:', 'https:')
              this.facture = this._sanitizer.bypassSecurityTrustResourceUrl(urlids);
          }
          this.myStepper.next()
        }
      });
    }
  }

  listenerIframe(e) {
    let data = e.data;
    if (data.hasOwnProperty('action') && e.origin === this.ODOO_URL) {
      if (data.action === 'publishHeight') {
        if(data.height < 500 ){ data.height = 500}
        (<HTMLElement> document.querySelector('iframe')).style.height = (data.height + 10) + 'px';
      } else if (data.action === 'isPageConfirmation') {
        this.myStepper.selectedIndex = 4;
        this.createDossierAfterPurchase()
      }
      /* deb #691 Google Analytics depuis devis Odoo sur les actions Payer/Télécharger et imprimer */
      if (data.action === 'gaPaye') {
        window['tryga']('send', 'event', 'achat', 'accepter_et_payer', '', '');
      }
      if (data.action === 'gaPayeConfirme') {
        window['tryga']('send', 'event', 'achat', 'accepter_et_payer_confirme', '', '');
      }
      if (data.action === 'gaTelecharge') {
        window['tryga']('send', 'event', 'achat', 'telecharger', '', '');
      }
      if (data.action === 'gaImprime') {
        window['tryga']('send', 'event', 'achat', 'imprimer', '', '');
      }
      /* fin #691 Google Analytics depuis devis Odoo sur les actions Payer/Télécharger et imprimer */
    }
  }
  
  ngOnDestroy(){
    window.removeEventListener('message',this.listenerIframe);
  }

  afterGetStore(res) {
    if(res && res.error){
      this.messageError = res.error
    }else{
      this.store = res.map((template) => template['variantes']).flat().sort((a, b) => (a.price > b.price ? 1 : -1));
      this.messageError = "";
      this.cdf.detectChanges();
      this.ajustHeight();
    }

  }

  ajustHeight() {
    let headerHeight = 0;
    let headers = document.querySelectorAll('.card-tarifs-header');
    headers.forEach(el =>{
      if (el.scrollHeight > headerHeight) {
        headerHeight = el.scrollHeight;
      }
    });
    headers.forEach(el =>{
      el.setAttribute('style', 'height: ' + headerHeight + 'px;');
    });
    let ribbonHeight = 0;
    let ribbons = document.querySelectorAll('.card-tarifs-ribbon');
    ribbons.forEach(el =>{
      if (el.scrollHeight > ribbonHeight) {
        ribbonHeight = el.scrollHeight;
      }
    });
    ribbons.forEach(el =>{
      let elHtmlElement = <HTMLElement> el;
      elHtmlElement.style.height = ribbonHeight + 'px';
    });
  }

  openLogin() {
    let dialogRef = this.dialog.open(LoginComponent, {
      height: '45%',
      width: '20%',
      data:{urlBack:'tarif'}
    })
  }

  secureImage(image:string){
    return this._sanitizer.bypassSecurityTrustResourceUrl(image);
  }

  addItem(item:any){
    window['tryga']('send', 'event', 'achat', 'ajouter_au_panier', '', '');
    this.cart.push(item);
  }

  totalPriceHT(){
    return this.cart.reduce((a, b) =>
        a + b.price
    , 0);
  }

  totalPriceTTC(){
    return this.cart.reduce((a, b) => a + b.price, 0) + Math.round(((this.cart.reduce((a, b) => a + b.price, 0))/100) * 20);
  }

  chechBeforeBuy() {
    return this.messageError || this.adresseForm.invalid;
  }

  buyItems(){
    
    if (this.adresseForm.valid) {
        this.isBuying = true;
        window['tryga']('send', 'event', 'achat', 'suivant_etape_3_adresse', '', '');
        let ids = [];
        // let quantity = 0;
        this.cart.forEach(element => {
        ids.push(element.id);
        // quantity += Number(element.cobham_unit_number);
        });
        let adresse = this.adresseForm.getRawValue();
        this.appService.saveAdresse(this.user.ID, adresse).subscribe((resAdr) => {
            console.log(resAdr);
            if(resAdr && resAdr.result && resAdr.result.error){
                this.isBuying = false;
                this.messageError = resAdr.result.error
            }else if(resAdr && resAdr.result){
                resAdr.result.user.credits = resAdr.result.credits;
                resAdr.result.user.identity.ID = resAdr.result.user.ID;
                resAdr.result.user.identity.email = resAdr.result.user.connection.email;
                resAdr.result.user.identity.adresse = resAdr.result.user.identity.adresse;
                this.stateService.updateUser(resAdr.result.user.identity);
                
                // this.customerService.BuyItems(ids, quantity).subscribe((res) => {
                this.customerService.BuyItems(ids).subscribe((res) => {
                    this.isBuying = false;
                    if(res.result.error){
                        this.messageError = res.result.error
                    }else{
                        this.messageError = ""
                        if(res && res.result && res.result.result) {
                            this.refCart = res.result.result.order_id

                            let url = res.result.result.url_confirmation.replace('http:', 'https:')
                            this.url_confirmation = this._sanitizer.bypassSecurityTrustResourceUrl(url);
                            
                            let urlids = res.result.result.urlcustomer.replace('http:', 'https:')
                            this.facture = this._sanitizer.bypassSecurityTrustResourceUrl(urlids);
                        }
                        this.myStepper.next()
                    }
                });
            }
        });
    } else {
        this.validateAllFormFields(this.adresseForm);
    }
  }

  checkEmpty(){
    let ids = []
    let quantity = 0
    this.cart.forEach(element => {
      ids.push(element.id)
      quantity += Number(element.cobham_unit_number)
    })
    if(quantity == 0)
      return true
    return false
  }

  deleteItem(index){
    window['tryga']('send', 'event', 'achat', 'retirer_du_panier', '', '');
    if(this.cart[index])
    this.cart.splice(index, 1)
  }
  ignore(){
    this.customerService.ignorePayment(this.cart, this.refCart).subscribe((res) => {
      if(res.result.error){
        this.messageError = res.result.error
      }else{
        this.messageError = ""
        this.user.credits = res.result.credits;
        this.stateService.updateUser(this.user);
        
        this.myStepper.selectedIndex = 4;
      }
    });
  }

  autoVille(event:any){
    this.optionsVille = "";
    let value = ""
    if( isString(event) ){
      value = event;
    }else{
      value = event.target.value;
    }
    if( value.length === 5){
      this.customerService.autoVille(value).subscribe((res)=>{
        if(res.result && res.result.ville){
          this.optionsVille = res.result.ville;
        }
      })
    }
  }

  nextFirstStep() {
    this.myStepper.next();
    window['tryga']('send', 'event', 'achat', 'suivant_etape_1', '', '');
  }  

  nextSecondStep() {
    this.myStepper.next();
    window['tryga']('send', 'event', 'achat', 'suivant_etape_2_recap', '', '');
  }  

  prevSecondStep() {
    this.myStepper.previous();
    window['tryga']('send', 'event', 'achat', 'precedent_etape_2_recap', '', '');
  }

  prevThirdStep() {
    window['tryga']('send', 'event', 'achat', 'precedent_etape_3_adresse', '', '');
    this.myStepper.previous();
  }

    validateAllFormFields(formGroup: FormGroup) {
        Object.keys(formGroup.controls).forEach(field => {
            const control = formGroup.get(field);
            if (control instanceof FormControl) {
                control.markAsTouched({ onlySelf: true });
            } else if (control instanceof FormGroup) {
                this.validateAllFormFields(control);
            }
        });
    }

    isInputInvalid(form: FormGroup, field: string) {
        return !form.get(field).valid && form.get(field).touched;
    }
  
  createDossierAfterPurchase() {
    if (this.directDevis && !this.waitingDossierCreation && !this.refDossier) {
      this.waitingDossierCreation = true;
      setTimeout(function() {
        this.appService.addBasicDossier().subscribe((res) => {
          if(res.result.displayID) {
            this.refDossier = res.result.displayID;
          }
          this.waitingDossierCreation = false;
        });
      }, 5000);
    }
  }
}
